<app-manage-template [title]="'Edit Business'" [FIELDS]="fields" [COLUMNFIELDS]="columns"
[userData]="(userDatas | async)"   [parentData]="businessContactDetails" [KEY]="'B2B_CONTACTS'"
(updateParent)="updateBusinessNetwork($event)" [holder]="'Search by member or email'" [ownerView]="true"
(updateMembers)="updateBusinessNetworkMembers($event)" [onSearch]="onSearch"
[onFilter]="onFilter" [this]="this" [onScroll]="onScroll">

<div type>

  <ng-select [items]="businessTypeList"
    [clearable]="false"
    [searchable]="false"
    (change)="onTypeChange()"
    bindLabel="label"
    bindValue="label"
    placeholder="Select Business Type"
    [(ngModel)]="selectedBusinessType"
    class="frayed"
    [disabled]="true"
  >
  </ng-select>

</div>

<div network>
  <div class="dropdown-container" [class.disabled]="businessContactDetails?.connectionStatus === 'REQUEST_RECEIVED'">
    <ng-select
    [items]="b2bNetworkList"
    [multiple]="true"
    [virtualScroll]="true"
    loadingText="Loading..."
    bindLabel="b2bNetworkName"
    bindValue="b2bNetworkId"
    placeholder="Select Network"
    [formControl]="selectedNetwork"
    class="multiselectlable"
    [closeOnSelect]="false"
    [hideSelected]="true"
    (blur)="confirmNetworkChange()"
  >
    <!-- Custom option row — same checkbox markup the job form uses
         (`bussiness-post.component.html:769-773`) so it picks up the
         global `.ng-select-checkbox-label` / `.ng-select-checkmark`
         styling from `_ng-select.scss:490-583`. -->
    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
      <div class="ng-select-checkbox-label" [attr.title]="item?.b2bNetworkName">
        <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
        <span class="ng-select-checkbox-text">{{ item.b2bNetworkName }}</span>
      </div>
    </ng-template>

    <!-- Custom selected-chip label — uses `.ng-value-label` so the
         global multi-select chip styling (`_ng-select.scss`) handles
         font / padding / ellipsis. -->
    <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
      <div class="selected-item" [attr.title]="item?.b2bNetworkName">
        <span class="ng-value-clear remove-icon" (click)="clear(item)">
          ✕
        </span>
        <span class="ng-value-label">{{ item.b2bNetworkName }}</span>
      </div>
    </ng-template>
  </ng-select>

    <!-- Overlay for disabled state -->
    <div class="overlay" *ngIf="businessContactDetails?.connectionStatus === 'REQUEST_RECEIVED'"></div>
  </div>

  <!-- Error message if no network is selected -->
  <div class="text-danger" *ngIf="selectedNetwork?.errors?.required&&businessContactDetails?.connectionStatus != 'REQUEST_RECEIVED'">
    Network is required.
  </div>
</div>

<div subContractAllowed>
  <ng-container *ngIf="selectedBusinessType === 'Supplier' || selectedBusinessType === 'Customer/Supplier'; else readOnlySubContract">
    <label class="custom-switch">
      <input type="checkbox"
             [checked]="subContractAllowed"
             (click)="$event.preventDefault(); onSubContractToggle()"
             [disabled]="businessContactDetails?.connectionStatus !== 'CONNECTED'">
      <span class="custom-slider"></span>
    </label>
  </ng-container>
  <ng-template #readOnlySubContract>
    <span class="sub-contract-badge"
          [class.allowed]="subContractAllowed"
          [class.not-allowed]="!subContractAllowed">
      {{ subContractAllowed ? 'Allowed' : 'Not Allowed' }}
    </span>
  </ng-template>
</div>

</app-manage-template>
